import clean from 'lodash-clean';
import Vue from 'vue';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'; // eslint-disable-line
import infiniteScroll from 'vue-infinite-scroll';
import ClickOutside from 'vue-click-outside';
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion';
import Treeselect from '@riophae/vue-treeselect';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import ListItem from '../ListItem.vue';
import SolrService from '@/common/solr.service';
import StorageService from '@/common/storage.service';
import ModalContentFactory from '../ModalContentFactory/ModalContentFactory.vue';
import Spinner from '../Spinner.vue';
import ProgramItem from '../ProgramItem.vue';
import SpeakerItem from '../SpeakerItem.vue';
import {
  SolrNewsTypeName,
  SolrExhibitorTypeName,
  SolrProductTypeName,
  SolrBrandTypeName,
  SolrFrameworkProgramTypeName,
  SolrSpeakerTypeName
} from '@/common/Utility';
import '@/assets/swiper/swiper.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import LanguageService from '@/common/language.service';
import { LANGUAGE_EN, ICS_LOCATIONS } from '@/common/constants';

import { addScrollStickyListener, removeScrollStickyListener } from '../../common/scrollSticky';
import { LMS_URL } from '../../common/config';

export default {
  name: 'ExhibitorDirectory',
  components: {
    Treeselect,
    Spinner,
    swiper,
    swiperSlide,
    BulmaAccordion,
    BulmaAccordionItem,
    ModalContentFactory,
    'ed-list-item': ListItem,
    'ed-program-item': ProgramItem,
    'ed-speaker-item': SpeakerItem,
    DateRangePicker,
  },
  data() {
    return {
      navHeight: 70,
      frameworkProgram: false,
      speakers: false,
      exhibitors: false,
      news: false,
      products: false,
      all: false,

      urlParamsChecked: false,

      filterApplied: false,

      categories: [],
      extraCategories: [],

      options: {
        isLoading: false,
        hasPrintButton: false,
        windowWidth: 0,
        swiper: {
          slidesPerView: 1,
        },
        accordion: {
          animation: {
            duration: '200ms',
            timerFunc: 'ease',
          },
        },
        sorting: {
          default: ['A-Z', 'Z-A'],
          frameWorkProgram: [this.$t('sorting.asc'), this.$t('sorting.desc')],
          news: [`${this.$t('detail.date')} ${this.$t('sorting.asc')}`, `${this.$t('detail.date')} ${this.$t('sorting.desc')}`],
        },
        contactSwiper: {
          // slidesPerView: 'auto',
          slidesPerView: 4,
          watchOverflow: true,
          slidesPerColumn: 1,
          autoHeight: true,
          // width: 250,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            550: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 3,
            },
          },
        },
        productSwiper: {
          slidesPerView: 1,
          autoHeight: true,
          watchOverflow: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
        },
        // brandSwiper: {
        //   slidesPerView: 4,
        //   autoHeight: true,
        //   watchOverflow: true,
        //   navigation: {
        //     prevEl: '.swiper-button-prev',
        //     nextEl: '.swiper-button-next',
        //   },
        //   pagination: {
        //     el: '.swiper-pagination',
        //     type: 'bullets',
        //     clickable: true,
        //   },
        //   breakpoints: {
        //     550: {
        //       slidesPerView: 1,
        //     },
        //     768: {
        //       slidesPerView: 2,
        //     },
        //     1024: {
        //       slidesPerView: 3,
        //     },
        //     1280: {
        //       slidesPerView: 4,
        //     },
        //   },
        // },
        badgesSwiper: {
          slidesPerView: 4,
          watchOverflow: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 2,
            },
            1280: {
              slidesPerView: 3,
            },
          },
        },
        boothSwiper: {
          slidesPerView: 5,
          watchOverflow: true,
          autoHeight: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
            },
            480: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            },
          },
        },
        tabSwiper: {
          slidesPerView: 3,
          watchOverflow: true,
          autoHeight: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          breakpoints: {
            320: {
              slidesPerView: 2,
            },
            480: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 5,
            },
          },
        },
        mediaSwiper: {
          slidesPerView: 3,
          autoHeight: true,
          watchOverflow: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            480: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          },
        },
      },
      list: {
        displayedAmount: 25, // as much as "amountToLoad", see mounted hook
        amount: 0,
        offset: 0,
        items: [],
        itemsPushed: [],
        isTileMode: false,
        isSwitchVisible: true,
        isLoading: true,
        sorting: 'asc',
        lastSort: 'asc',
        hallSortArray: [],
        countOfTypes: [],
      },
      parsedLimitedFairUids: JSON.parse(this.limitedFairEvents),
      fairTitleMapping: {},
      splittedCategoriesLoaded: false,
      latestNews: [],
      resultObject: {
        payload: '',
        term: '',
        weight: 0,
      },
      filter: {
        limitedFairEvents: '',
        isFilterVisible: false,
        autocomplete: {
          isVisible: false,
          isLoading: false,
          arrowCounter: -1,
          results: [],
        },
        fairGroups: {
          defaultExpandLevel: 1,
          filterValue: [],
          options: [],
        },
        types: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        categoriesByFair: null,
        extraCategoriesByFair: null,
        categories: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        extraCategories: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        news: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        travelDestinations: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        halls: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        countries: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        spaces: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        timeOfDay: {
          defaultExpandLevel: 0,
          filterValue: {id: 'day', label: this.$t('filter.timeOfDay.options.fullDay')},
          options: [
            {id: 'day', label: this.$t('filter.timeOfDay.options.fullDay')},
            {id: 'morning', label: this.$t('filter.timeOfDay.options.morning')},
            {id: 'afternoon', label: this.$t('filter.timeOfDay.options.afternoon'), }
          ],
        }
      },
      fpConfigurationFilter: {},
      detail: {
        isDetailVisible: false,
        entry: null,
        categories: [],
      },
      favourites: {
        showFavourites: false,
        items: [],
        itemsProgram: [],
      },
      showLatestNews: true,
      newsOnly: false,
      exhibitorsTopOfTheList: [],
      pluginConfiguration: {
        limitedFairEvents: this.limitedFairEvents,
        fairGroups: this.fairGroups,
      },
      router: {
        oldRoute: null,
      },
      eventLookup: {},
      showToTopButton: false,
      pickedDate: {},
      eventMinDate: null,
      eventMaxDate: null,
      configurationMinDate: null,
      configurationMaxDate: null,
      locale: {
        format: 'dd.mm.yyyy',
        separator: ' - ',
        applyLabel: 'Speichern',
        cancelLabel: 'Abbrechen',
      },
      fpConfigurations: [],
    };
  },
  props: {
    lang: {
      Type: String,
      default: 'de',
    },
    terminalmode: {
      type: Boolean,
      default: false,
    },
    aside: {
      type: Boolean,
      default: false,
    },
    onlySearch: {
      type: Boolean,
      default: false,
    },
    limitedFairEvents: {
      type: String,
      default: '',
    },
    fairGroups: {
      type: String,
      default: '',
    },
    listUrl: {
      type: String,
      default: '',
    },
    hallplanPath: {
      type: String,
      default: '',
    },
    timeTablePath: {
      type: String,
      default: '',
    },
    woozlePath: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    expandedCategories: {
      type: Boolean,
      default: false,
    },
    expandCategoryDropdown: {
      type: Boolean,
      default: false,
    },
    splittedCategories: {
      type: Boolean,
      default: false,
    },
    hideResultAmount: {
      type: Boolean,
      default: false,
    },
    fairGroupsTitle: {
      type: String,
      default: 'Themenwelten',
    },
    hallsTitle: {
      type: String,
      default: 'Hallen',
    },
    categoriesTitle: {
      type: String,
      default: 'Kategorien',
    },
    extraCategoryTitle: {
      type: String,
      default: '',
    },
    travelDestinationTitle: {
      type: String,
      default: 'Reiseziele',
    },
    topOfTheListColor: {
      type: String,
      default: '',
    },
    topOfTheListOpacity: {
      type: Number,
      default: 0.8,
    },
    frameworkProgramProp: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: '',
    },
  },
  computed: {
    computedMinDate() {
      return this.configurationMinDate === null || this.eventMinDate < this.configurationMinDate ?
        this.eventMinDate :
        this.configurationMinDate;
    },
    computedMaxDate() {
      return this.configurationMaxDate === null || this.eventMaxDate > this.configurationMaxDate ?
        this.eventMaxDate :
        this.configurationMaxDate;
    },
    getLocale() {
      return LanguageService.getCurrentTYPO3Language() === LANGUAGE_EN ? 'en-EN' : 'de-DE';
    },
    getFilterQueryString() {
      if (
        this.filter.types
        && this.filter.categories
        && this.filter.extraCategories
        && this.filter.travelDestinations
        && this.filter.fairGroups
        && this.filter.halls
        && this.filter.countries
      ) {
        return SolrService.getExhibitorData(
          this.resultObject.term.trim() ? this.resultObject.term.trim().toLowerCase() : '*:*',
          this.pluginConfiguration.limitedFairEvents,
          this.filter.types.filterValue,
          this.filter.categories.filterValue,
          this.filter.extraCategories.filterValue,
          this.favourites.showFavourites,
          this.getFavourites(),
          this.filter.travelDestinations.filterValue,
          this.filter.fairGroups.filterValue,
          this.filter.halls.filterValue,
          this.filter.countries.filterValue,
          0,
          10,
          this.list.sorting,
          false,
          true
        );
      }
      return '';
    },
    getCount() {
      const fullType = [{id: 'exhibitor', type: [this.getExhibitorType]}, {id: 'news', type: [this.getNewsType]}, {id: 'all', type: [this.getExhibitorType, this.getNewsType]}, {id: 'frameworkProgram', type: [this.getFrameworkProgramType]}, {id: 'speaker', type: [this.getSpeakerType]}];
      const count = {};

      fullType.forEach((fullTypeItem) => {
        count[fullTypeItem.id] = 0;
        this.list.countOfTypes.forEach((itemType) => {
          fullTypeItem.type.forEach((fullTypeItemType) => {
            if (itemType.val === fullTypeItemType) {
              count[fullTypeItem.id] += itemType.count;
            }
          });
        });
      });
      count.exhibitor += this.exhibitorsTopOfTheList.length;
      count.all += this.exhibitorsTopOfTheList.length;
      return count;
    },
    getAvatarImg() {
      if (this.path) {
        return `/${this.path}/typo3conf/ext/messe_exhibitordirectory_azure/src/assets/images/avatar_man_icon.png`;
      }
      return '/typo3conf/ext/messe_exhibitordirectory_azure/src/assets/images/avatar_man_icon.png';
    },
    dateToday() {
      if (Date.now() < this.eventMinDate || Date.now() > this.eventMaxDate) {
        return new Date(this.eventMinDate);
      }
      return Date.now();
    },
    getFairId() {
      return JSON.parse(this.limitedFairEvents)[0];
    },
    amountToLoad() {
      if (this.terminalmode) {
        return 700;
      }
      return 25;
    },
    areAllCategoriesByFairsVisible() {
      return this.filter.fairGroups.filterValue.length === 0;
    },
    filterable() {
      return true;
    },
    filterButtonTooltip() {
      if (this.filter.isFilterVisible) {
        return this.$t('filter.close');
      }
      return this.$t('filter.open');
    },
    viewSizeMode() {
      let sizeMode = -1;
      if (this.options.windowWidth <= 768) {
        sizeMode = 0; /* tiny */
      } else if (this.options.windowWidth > 768 && this.options.windowWidth <= 1024) {
        sizeMode = 1; /* small */
      } else if (this.options.windowWidth > 1024 && this.options.windowWidth <= 1280) {
        sizeMode = 2; /* medium */
      } else if (this.options.windowWidth > 1280) {
        sizeMode = 3; /* big */
      }
      return sizeMode;
    },
    amountOfResultsShown() {
      let amount;
      amount = `${this.$t('list.results')}`;
      amount = `${this.formatNumber(this.list.amount)} ${this.$t('list.results')}`;
      if ((this.favourites.showFavourites && this.favourites.items.length > 0) || (this.favourites.showFavourites && this.favourites.itemsProgram.length > 0)) {
        if (this.list.amount === 0) {
          amount = '';
        } else if (this.list.amount === 1) {
          amount = `${this.list.amount} ${this.$t('list.favouriteTooltip.name.singular')}`;
        } else {
          amount = `${this.formatNumber(this.list.amount)} ${this.$t('list.favouriteTooltip.name.plural')}`;
        }
      } else if (this.list.amount === 0) {
        amount = '';
      } else if (this.list.amount === 1) {
        amount = `${this.list.amount} ${this.$t('list.result')}`;
      }
      return amount;
    },
    areNoItemsLeft() {
      return this.list.displayedAmount >= this.list.amount;
    },
    areFiltersActive() {
      return this.filter.fairGroups.filterValue.length
        || this.filter.types.filterValue.length
        || this.filter.categories.filterValue.length
        || this.filter.extraCategories.filterValue.length
        || this.filter.travelDestinations.filterValue.length
        || this.filter.halls.filterValue.length
        || this.filter.spaces.filterValue.length
        || this.filter.countries.filterValue.length
        || Object.keys(this.fpConfigurationFilter).some(key => this.fpConfigurationFilter[key].filterValue.length);
    },
    showFairGroupsTree() {
      return this.filter.fairGroups.options.length > 1;
    },
    showTypesTree() {
      return this.filter.types.options.length > 1 && this.filter.types.options[0].id !== '|' && !this.exhibitors && !this.all;
    },
    showCategoriesTree() {
      return (this.filter.categories.options.length > 0 && this.filter.categories.options[0].id !== '|') || this.splittedCategories;
    },
    showExtraCategoriesTree() {
      return (this.filter.extraCategories.options.length > 0 && this.filter.extraCategories.options[0].id !== '|') || this.splittedCategories;
    },
    showTravelDestinationsTree() {
      return this.filter.travelDestinations.options.length > 0 && this.filter.travelDestinations.options[0].id !== '|';
    },
    showHallsTree() {
      return this.filter.halls.options.length > 1 && this.filter.halls.options[0].id !== '|' && (this.filter.halls.options[0].id.toLowerCase() !== 'undefiniert' && this.filter.halls.options[0].id.toLowerCase() !== 'undefined');
    },
    showCountriesTree() {
      return this.filter.countries.options.length > 1 && (this.filter.countries.options[0].id.toLowerCase() !== 'undefiniert');
    },
    showSpacesTree() {
      return this.filter.spaces.options.length > 1 && (this.filter.spaces.options[0].id.toLowerCase() !== 'undefiniert');
    },
    showFilter() {
      let show = true;
      // this.filter.types.filterValue.forEach((typeFilter) => {
      //   if (typeFilter.id === SolrNewsTypeName && this.filter.types.filterValue.length === 1) {
      //     show = false;
      //   }
      // });
      if (this.news) {
        show = false;
      }
      return show;
    },
    showTypesFilter() {
      const emptyFilter = this.filter.travelDestinations.filterValue.length === 0
        && this.filter.categories.filterValue.length === 0
        && this.filter.halls.filterValue.length === 0
        && this.filter.countries.filterValue.length === 0;

      const otherFilterSelected = this.filter.travelDestinations.filterValue.length > 0
        || this.filter.categories.filterValue.length > 0
        || this.filter.halls.filterValue.length > 0
        || this.filter.countries.filterValue.length > 0;

      return emptyFilter || !otherFilterSelected;
    },
    areTreesShown() {
      return this.showFairGroupsTree
        || this.showTypesTree
        || this.showHallsTree
        || this.showCountriesTree
        || this.showCategoriesTree
        || this.showExtraCategoriesTree
        || this.showTravelDestinationsTree
        || this.speakers
        || this.frameworkProgram;
    },
    sortingLabels() {
      if (this.frameworkProgram) {
        return this.options.sorting.frameWorkProgram;
      }
      if (this.news) {
        return this.options.sorting.news;
      }
      return this.options.sorting.default;
    },
    sortingOptions() {
      return [
        {id: 'asc', label: this.sortingLabels[0]},
        {id: 'desc', label: this.sortingLabels[1]},
      ];
    },
    getNewsType() {
      return SolrNewsTypeName;
    },
    getSpeakerType() {
      return SolrSpeakerTypeName;
    },
    getExhibitorType() {
      return SolrExhibitorTypeName;
    },
    getFrameworkProgramType() {
      return SolrFrameworkProgramTypeName;
    },
    getProductType() {
      return SolrProductTypeName;
    },
    getRGBColor() {
      return this.parseHexToRgb(this.topOfTheListColor);
    },
    getTopOfTheListStyle() {
      if (this.getRGBColor !== null) {
        if (!Number.isNaN(this.topOfTheListOpacity)) {
          return `background: rgba(${this.getRGBColor.r},${this.getRGBColor.g},${this.getRGBColor.b}, ${this.topOfTheListOpacity});`;
        }
        return `background: rgba(${this.getRGBColor.r},${this.getRGBColor.g},${this.getRGBColor.b}, 0.8);`;
      }
      return '';
    },
    downloadUrl() {
      return `${LMS_URL}/api/lms2818f/export/${this.getFairId}/${this.$i18n.locale}${this.getFilterQueryString}`;
    }
  },
  created() {
    this.options.windowWidth = window.innerWidth;
    this.updateView();
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    removeScrollStickyListener(this.navHeight);
  },
  async mounted() {
    // we have to call updateView() at created and mounted
    // because treeselect isn't ready at created
    // but mounted is too late for the layout adjustments (jumps in frontend)
    // be careful with the order of your code!
    // this.exhibitors is watched but filters exist later(mounted) and must to be filled before watch is triggered

    this.list.displayedAmount = this.amountToLoad;
    if (this.expandedCategories) {
      this.filter.categories.defaultExpandLevel = 1;
    }

    this.fpConfigurations = await SolrService.getFrameworkProgramConfigurations(this.parsedLimitedFairUids);

    const events = await SolrService.getFairEvents(this.parsedLimitedFairUids);
    const eventLookup = {};
    events.data.response.docs.forEach((ev) => {
      const event = {};
      event[ev.fair_id] = ev;
      if (ev.av_categories_fair) {
        ev.av_categories_fair.forEach(c => this.categories.push({count: null, val: c}));
      }
      if (ev.av_categories_fair_extra) {
        ev.av_categories_fair_extra.forEach(c => this.extraCategories.push({count: null, val: c}));
      }

      Object.assign(eventLookup, event);
    });

    if (this.$route.name !== 'Speaker') {
      this.frameworkProgram = this.frameworkProgramProp;
      if (this.frameworkProgram === false) {
        this.exhibitors = true;
      }
    } else if (this.$route.name === 'Speaker') {
      this.speakers = true;
      this.exhibitors = false;
    }
    if (this.frameworkProgram === true) {
      this.exhibitors = false;
    }

    Vue.set(this, 'eventLookup', eventLookup);

    this.getMinMaxDate(eventLookup);

    this.fetchDataFromRouter();
    this.updateView();
    if (this.frameworkProgram || this.speakers) {
      this.pickedDate = {startDate: this.dateToday, endDate: new Date(this.eventMaxDate)};
    }
    if (this.speakers && this.$route.name !== 'Speaker' && this.$route.name !== 'SpeakerDetail') {
      await this.$router.push({ name: 'Speaker' });
    } else if (this.frameworkProgram && this.$route.name !== 'FrameworkProgram' && this.$route.name !== 'FrameworkProgramDetail') {
      await this.$router.push({ name: 'FrameworkProgram' });
    } else if (this.exhibitors && this.$route.name !== 'Exhibitor' && this.$route.name !== 'ExhibitorDetail') {
      await this.$router.push({name: 'Exhibitor'});
    } else if (this.news && this.$route.name !== 'News' && this.$route.name !== 'NewsDetail') {
      await this.$router.push({ name: 'News' });
    } else if (this.all && this.$route.name !== 'Directory' && this.$route.name !== 'DirectoryDetail') {
      await this.$router.push({ name: 'Directory' });
    }
    if (this.exhibitors) {
      this.favourites.items = this.getFavourites();
    } else if (this.frameworkProgram) {
      this.favourites.itemsProgram = this.getFavourites();
    }
    if (this.$route.name === 'ExhibitorFavourites' || this.$route.name === 'ProgramFavourites') {
      this.toggleFavourites();
    }

    if (!this.onlySearch) {
      if (sessionStorage.getItem('lms_query') !== null) {
        const query = sessionStorage.getItem('lms_query');
        try {
          this.resultObject = JSON.parse(query);
        } catch (e) {
          // If no object is given we start a normal search
          this.resultObject.term = query;
          this.resultObject.payload = '[{"type":"searchFromDifferentLocation"}]';
        }
        sessionStorage.removeItem('lms_query');
        this.autocompleteSearch(this.resultObject);
      }
    }

    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.options.windowWidth = window.innerWidth;
        this.updateView();
        /* @todo: reinit slides */
      });
    });
    document.body.addEventListener('keyup', (e) => {
      // 27 = ESC
      if (e.keyCode === 27) {
        this.closeDetail();
      }
    });

    this.initStickyScroll();
  },
  methods: {
    initStickyScroll() {
      const header = document.querySelector('.header__nav');
      const faceliftHeader = document.querySelector('.new-header');
      const offset = 30;
      if (faceliftHeader) {
        this.navHeight = faceliftHeader.clientHeight + offset;
      } else if (header) {
        this.navHeight = header.clientHeight + offset;
      }
      addScrollStickyListener(this.navHeight);
    },
    getSpaceFacetValues(spaces) {
      let spaceArray = [];
      let icsArray = [];
      let spaceVal;
      spaces.forEach((space) => {
        try {
          spaceVal = JSON.parse(space.val).translations.de.title;
        } catch {
          spaceVal = space.val;
        }

        // group all spaces beginning with C e.g C4.1 (ICS spaces) together
        if (spaceVal[0] === 'C' && Number.parseInt(spaceVal[1], 10)) {
          icsArray.push(spaceVal);
          spaceVal = this.$t('filter.ics');
        }
        if (spaceVal !== 'Veranstaltung am Messestand') {
          spaceArray.push(spaceVal);
        }
      });

      // distinct values
      spaceArray = spaceArray.filter((value, index, array) => array.indexOf(value) === index);
      icsArray = icsArray.filter((value, index, array) => array.indexOf(value) === index);

      icsArray = icsArray.sort((a, b) => {
        if (a < b) {
          return -1;
        }
        return 1;
      });

      // put all ICS spaces in a 2 dimensional array
      spaceArray[spaceArray.indexOf(this.$t('filter.ics'))] = [this.$t('filter.ics'), icsArray];

      return spaceArray.sort((a, b) => {
        if (a < b) {
          return -1;
        }
        return 1;
      });
    },
    getMinMaxDate(events) {
      this.filter.isLoading = true;
      let eventMinDate = null;
      let eventMaxDate = null;
      let configurationMinDate = null;
      let configurationMaxDate = null;
      Object.keys(events).forEach((key) => {
        const eventStartDate = new Date(events[key].fp_starttime);
        const eventEndDate = new Date(events[key].fp_endtime);

        // Ensure valid dates
        const isValidDate = date => date instanceof Date && !Number.isNaN(date.getTime());

        const configuration = this.fpConfigurations.find(c => c.fair_ids.includes(key));

        const configurationStartDate =
          configuration && configuration.fp_configuredStartDate_stringS ?
            new Date(configuration.fp_configuredStartDate_stringS) :
            null;
        const configurationEndDate =
          configuration && configuration.fp_configuredEndDate_stringS ?
            new Date(configuration.fp_configuredEndDate_stringS) : null;

        if (isValidDate(eventStartDate) && (!eventMinDate || eventStartDate < eventMinDate)) {
          eventMinDate = eventStartDate;
        }

        if (isValidDate(eventEndDate) && (!eventMaxDate || eventEndDate > eventMaxDate)) {
          eventMaxDate = eventEndDate;
        }

        if (isValidDate(configurationStartDate) && (!configurationMinDate || configurationStartDate < configurationMinDate)) {
          configurationMinDate = configurationStartDate;
        }

        if (isValidDate(configurationEndDate) && (!configurationMaxDate || configurationEndDate > configurationMaxDate)) {
          configurationMaxDate = configurationEndDate;
        }
      });

      this.eventMinDate = eventMinDate;
      this.configurationMinDate = configurationMinDate;
      this.eventMaxDate = eventMaxDate;
      this.configurationMaxDate = configurationMaxDate;
      this.filter.isLoading = false;
    },
    showProgramDetailOfSpeaker(entry) {
      const programId = this.getNumericId(entry[0].id);
      this.$router.push({name: 'FrameworkProgramDetail', params: {programId}});
    },
    showSpeakerDetailOfProgram(entry) {
      const speakerId = this.getNumericId(entry[0]);
      this.$router.push({name: 'SpeakerDetail', params: {speakerId}});
    },
    showNewsDetailOfExhibitor(entry) {
      const newsId = this.getNumericId(entry[0].id);
      this.$router.push({name: 'NewsDetail', params: {newsId}});
    },
    showFrameworkProgramPage() {
      this.speakers = false;
      this.frameworkProgram = true;
      this.exhibitors = false;
      this.news = false;
      this.products = false;
      this.all = false;
      this.list.displayedAmount = this.amountToLoad;
      this.list.sorting = 'asc';
      if (this.frameworkProgram && this.$route.name !== 'FrameworkProgram') {
        this.$router.push({name: 'FrameworkProgram'});
      }
    },
    showSpeakersPage() {
      this.speakers = true;
      this.frameworkProgram = false;
      this.exhibitors = false;
      this.news = false;
      this.products = false;
      this.all = false;
      this.list.displayedAmount = this.amountToLoad;
      this.list.sorting = 'asc';
      if (this.speakers && this.$route.name !== 'Speaker') {
        this.$router.push({ name: 'Speaker' });
      }
    },
    showExhibitorsPage() {
      this.speakers = false;
      this.frameworkProgram = false;
      this.exhibitors = true;
      this.all = false;
      this.news = false;
      this.products = false;
      this.list.displayedAmount = this.amountToLoad;
      this.list.sorting = 'asc';
      if (this.exhibitors && this.$route.name !== 'Exhibitor') {
        this.$router.push({name: 'Exhibitor'});
      }
    },
    showNewsPage() {
      this.speakers = false;
      this.frameworkProgram = false;
      this.exhibitors = false;
      this.news = true;
      this.all = false;
      this.products = false;
      this.list.displayedAmount = this.amountToLoad;
      this.list.sorting = 'asc';
      if (this.news && this.$route.name !== 'News') {
        this.$router.push({name: 'News'});
      }
    },
    showAll() {
      this.speakers = false;
      this.frameworkProgram = false;
      this.exhibitors = false;
      this.news = false;
      this.all = true;
      this.list.displayedAmount = this.amountToLoad;
      this.list.sorting = 'asc';
      if (this.all && this.$route.name !== 'Directory') {
        this.$router.push({name: 'Directory'});
      }
    },
    toTop() {
      window.scrollTo({
        top: 350,
        behavior: 'smooth',
      });
    },
    async fetchAll(offset, rows, firstLoad) {
      this.list.isLoading = true;

      try {
        const response = await SolrService.getAllData(
          this.resultObject.term.trim() ? this.resultObject.term.trim().toLowerCase() : '*:*',
          this.pluginConfiguration.limitedFairEvents,
          this.filter.types.filterValue,
          this.filter.categories.filterValue,
          this.filter.extraCategories.filterValue,
          this.favourites.showFavourites,
          this.getFavourites(),
          this.filter.travelDestinations.filterValue,
          this.filter.fairGroups.filterValue,
          this.filter.halls.filterValue,
          this.filter.countries.filterValue,
          offset,
          rows,
          this.list.sorting,
        );

        this.list.amount = response.data.response.numFound;
        this.list.offset = response.data.response.start;
        this.list.countOfTypes = response.data.facets.typeReduced.buckets;

        const items = response.data.response.docs.map((i) => {
          if (i.av_exhibitor_brands) {
            i.av_exhibitor_brands = JSON.parse(i.av_exhibitor_brands);
          }
          return i;
        });

        // @todo: LMS117SUS-2840 - remove
        if (this.resultObject.term.toLowerCase() === 'rom' || this.resultObject.term.toLowerCase() === 'roma' || this.resultObject.term.toLowerCase() === 'roma ') {
          const romaIndex = items.findIndex(ex => ex.titleExact === 'ROMA KG');

          if (romaIndex > 0) {
            const roma = items[romaIndex];
            items.splice(romaIndex, 1);
            items.splice(0, 0, roma);
          }
        }

        if (this.list.lastSort === this.list.sorting) {
          if (firstLoad) {
            this.list.itemsPushed = items;
          } else {
            this.list.itemsPushed.push(...items);
          }
        } else {
          this.list.itemsPushed = items;
          this.list.lastSort = this.list.sorting;
        }

        /* split entries in letter groups */
        this.list.items = this.splitEntriesInLetterGroups(this.list.itemsPushed);
      } catch (e) {
        console.error(e);
      }
      this.list.isLoading = false;
    },
    async fetchExhibitors(offset, rows, firstLoad) {
      this.list.isLoading = true;
      /* only news filter is selected */
      if (this.filter.types.filterValue.length === 1
        && this.filter.types.filterValue[0].id === SolrNewsTypeName) {
        if (!this.newsOnly) {
          this.list.sorting = 'asc';
          this.newsOnly = true;
        }
      } else {
        this.newsOnly = false;
      }

      try {
        const response = await SolrService.getExhibitorData(
          this.resultObject.term.trim() ? this.resultObject.term.trim().toLowerCase() : '*:*',
          this.pluginConfiguration.limitedFairEvents,
          this.filter.types.filterValue,
          this.filter.categories.filterValue,
          this.filter.extraCategories.filterValue,
          this.favourites.showFavourites,
          this.getFavourites(),
          this.filter.travelDestinations.filterValue,
          this.filter.fairGroups.filterValue,
          this.filter.halls.filterValue,
          this.filter.countries.filterValue,
          offset,
          rows,
          this.list.sorting,
        );
        this.list.amount = response.data.response.numFound;
        this.list.offset = response.data.response.start;
        this.list.countOfTypes = response.data.facets.typeReduced.buckets;

        const items = response.data.response.docs.map((i) => {
          if (i.av_exhibitor_brands) {
            i.av_exhibitor_brands = JSON.parse(i.av_exhibitor_brands);
          }
          return i;
        });

        // @todo: LMS117SUS-2840 - remove
        if (this.resultObject.term.toLowerCase() === 'rom' || this.resultObject.term.toLowerCase() === 'roma' || this.resultObject.term.toLowerCase() === 'roma ') {
          const romaIndex = items.findIndex(ex => ex.titleExact === 'ROMA KG');

          if (romaIndex > 0) {
            const roma = items[romaIndex];
            items.splice(romaIndex, 1);
            items.splice(0, 0, roma);
          }
        }

        // const tempData = response.data.response.docs;
        // tempData.forEach((item) => {
        //   // eslint-disable-next-line
        //   item.boothsInFair = this.getBoothsForFair(item);
        // });

        if (this.list.lastSort === this.list.sorting) {
          if (firstLoad) {
            this.list.itemsPushed = items;
          } else {
            this.list.itemsPushed.push(...items);
          }
        } else {
          this.list.itemsPushed = items;
          this.list.lastSort = this.list.sorting;
        }

        /* split entries in letter groups */
        this.list.items = this.splitEntriesInLetterGroups(this.list.itemsPushed);

        /* Fill sorting for hall values, this is not beautiful but we had no other choice */
        this.fillHallSortingValues();

        /* create fairGroups from config */
        this.filter.fairGroups.options =
          this.buildFairTree(JSON.parse(this.pluginConfiguration.fairGroups));
        this.filter.types.options =
          this.buildTypeTree(response.data.facets.type.buckets);
        this.filter.travelDestinations.options =
          this.buildPathTree(response.data.facets.travel_destination.buckets);
        this.filter.halls.options =
          this.buildPathTree(this.sortHallValues(response.data.facets.hall.buckets));
        this.filter.countries.options =
          this.buildCountryTree(this.sortCountriesValues(response.data.facets.country.buckets));


        this.categories.filter(this.uniqueArray);
        this.extraCategories.filter(this.uniqueArray);

        if (!this.splittedCategories) {
          this.filter.categories.options =
            this.buildPathTree(this.categories);
          this.filter.extraCategories.options =
            this.buildPathTree(this.extraCategories);
        }
      } catch (e) {
        console.error(e);
      }

      if (firstLoad) {
        if (this.splittedCategories && !this.splittedCategoriesLoaded) {
          const parsedFairGroups = JSON.parse(this.fairGroups);
          [].forEach.call(parsedFairGroups, (parsedFairGroup) => {
            this.fairTitleMapping[parsedFairGroup.id] = parsedFairGroup.title;
          });
          this.fetchSplittedCategories();
        } else {
          this.updateView();
        }
      }
      this.list.isLoading = false;

      /* only get top of the list when there is a category filter selected */
      if (this.filter.categories.filterValue.length > 0) {
        await SolrService.getExhibitorData(
          this.resultObject.term.trim() ? this.resultObject.term.trim().toLowerCase() : '*:*',
          this.pluginConfiguration.limitedFairEvents,
          null,
          this.filter.categories.filterValue,
          this.filter.extraCategories.filterValue,
          this.favourites.showFavourites,
          this.getFavourites(),
          null,
          null,
          null,
          null,
          0,
          100,
          'asc',
          true,
        ).then((response) => {
          const topOfTheListReponse = response.data.response.docs;

          this.exhibitorsTopOfTheList = topOfTheListReponse.filter((ex) => {
            const categories = JSON.parse(ex.av_top_of_the_list_category);
            let exists = false;

            this.filter.categories.filterValue.forEach((fv) => {
              if (exists) {
                return;
              }
              exists = categories.includes(fv.id);
            });

            if (exists) {
              return true;
            }

            this.filter.extraCategories.filterValue.forEach((fv) => {
              if (exists) {
                return;
              }
              exists = categories.includes(fv.id);
            });

            return exists;
          });
        }).catch((error) => {
          console.error('error: ', error);
        });
      } else {
        this.exhibitorsTopOfTheList = [];
      }
    },

    splitEntriesInLetterGroups(itemsPushed) {
      const items = itemsPushed.reduce((newArray, arrayItem) => {
        const reg = /^\d+$/;
        let firstLetter;
        if (arrayItem.title !== undefined && arrayItem.title !== '') {
          if (reg.test(arrayItem.title[0])) {
            firstLetter = '#';
          } else {
            firstLetter = arrayItem.title[0].toLocaleUpperCase();
          }
        } else {
          firstLetter = '#';
        }

        const returnArray = newArray;
        if (returnArray[firstLetter]) {
          returnArray[firstLetter].push(arrayItem);
        } else {
          returnArray[firstLetter] = [arrayItem];
        }
        return returnArray;
      }, {});

      return items;
    },
    checkForUrlParams() {
      if (!this.urlParamsChecked) {
        const currentUrl = new URL(window.location.href);
        const categoryFilter = currentUrl.searchParams.get('catFilter');
        const spaceFilter = currentUrl.searchParams.get('spaceFilter');
        const extraCategoryFilter = currentUrl.searchParams.get('extraCatFilter');
        const fpConfigFilter = currentUrl.searchParams.get('fpConfigFilter');
        let timeOfDayFilter = null;
        let dateFilter = null;
        if (this.frameworkProgram || this.speakers) {
          timeOfDayFilter = currentUrl.searchParams.get('timeOfDayFilter');
          dateFilter = currentUrl.searchParams.get('dateFilter');
          if (dateFilter) {
            let dates = dateFilter.split(',');
            dates = dates.map(date => Number.parseInt(date, 10));
            this.pickedDate.startDate = new Date(dates[2], dates[1], dates[0]);
            this.pickedDate.endDate = new Date(dates[5], dates[4], dates[3]);
          }

          if (timeOfDayFilter) {
            // find object by id in options
            const filterId = timeOfDayFilter;
            const foundNode = this.findNode(filterId, this.filter.timeOfDay.options);
            if (foundNode) {
              this.filter.timeOfDay.filterValue = foundNode;
            }
          }
        }
        if (categoryFilter) {
          // find object by id in options
          const filterIds = categoryFilter.split(';:');
          filterIds.forEach((id) => {
            const foundNode = this.findNode(id, this.filter.categories.options);
            if (foundNode) {
              this.filter.categories.filterValue.push(foundNode);
            }
          });
        }

        if (spaceFilter) {
          // find object by id in options
          const filterIds = spaceFilter.split(';:');
          filterIds.forEach((id) => {
            const foundNode = this.findNode(id, this.filter.spaces.options);
            if (foundNode) {
              this.filter.spaces.filterValue.push(foundNode);
            }
          });
        }

        if (extraCategoryFilter) {
          const filterIds = extraCategoryFilter.split(';:');
          filterIds.forEach((id) => {
            const foundNode = this.findNode(id, this.filter.extraCategories.options);
            if (foundNode) {
              this.filter.extraCategories.filterValue.push(foundNode);
            }
          });
        }

        if (fpConfigFilter) {
          const filterIds = fpConfigFilter.split(';:');
          filterIds.forEach((id) => {
            Object.entries(this.fpConfigurationFilter).forEach(([index, value]) => {
              const foundNode = this.findNode(id, value.options);
              if (foundNode) {
                this.fpConfigurationFilter[index].filterValue.push(foundNode);
              }
            });
          });
        }

        if (categoryFilter || extraCategoryFilter || spaceFilter || timeOfDayFilter || dateFilter || fpConfigFilter) {
          this.applyFilter();
        }

        this.urlParamsChecked = true;
      }
    },
    // WARNING: this call might be dangerous on bigger arrays!!!!
    // eslint-disable-next-line consistent-return
    findNode(id, array) {
      // eslint-disable-next-line no-restricted-syntax
      for (const node of array) {
        if (node.id === id) {
          return node;
        }
        if (node.children) {
          const child = this.findNode(id, node.children);
          if (child) {
            return child;
          }
        }
      }
    },
    updateFiltersInUrl() {
      const currentUrl = new URL(window.location.href);
      const categoryFilter = currentUrl.searchParams.get('catFilter');
      const extraCategoryFilter = currentUrl.searchParams.get('extraCatFilter');
      const spaceFilter = currentUrl.searchParams.get('spaceFilter');

      if (this.frameworkProgram || this.speakers) {
        const timeOfDayFilter = currentUrl.searchParams.get('timeOfDayFilter');
        const dateFilter = currentUrl.searchParams.get('dateFilter');

        // check if timeOfDay is filtered
        if (this.filter.timeOfDay.filterValue.id !== '') {
          const filterString = this.filter.timeOfDay.filterValue.id;
          currentUrl.searchParams.set('timeOfDayFilter', filterString);
        } else if (timeOfDayFilter) {
          currentUrl.searchParams.delete('timeOfDayFilter');
        }
        // check if date is filtered
        if (this.pickedDate.startDate) {
          const start = new Date(this.pickedDate.startDate);
          const end = new Date(this.pickedDate.endDate);
          const filterString = `${start.getDate()},${start.getMonth()},${start.getFullYear()},${end.getDate()},${end.getMonth()},${end.getFullYear()}`;
          currentUrl.searchParams.set('dateFilter', filterString);
        } else if (dateFilter) {
          currentUrl.searchParams.delete('dateFilter');
        }
      }
      // check if categories are filtered
      if (this.filter.categories.filterValue.length) {
        let filterString = '';
        this.filter.categories.filterValue.forEach((filterItem) => {
          filterString += `;:${filterItem.id}`;
        });
        currentUrl.searchParams.set('catFilter', filterString);
      } else if (categoryFilter) {
        currentUrl.searchParams.delete('catFilter');
      }

      // check if extraCategories are filtered
      if (this.filter.extraCategories.filterValue.length) {
        let filterString = '';
        this.filter.extraCategories.filterValue.forEach((filterItem) => {
          filterString += `;:${filterItem.id}`;
        });
        currentUrl.searchParams.set('extraCatFilter', filterString);
      } else if (extraCategoryFilter) {
        currentUrl.searchParams.delete('extraCatFilter');
      }

      // check if spaces are filtered
      if (this.filter.spaces.filterValue.length) {
        let filterString = '';
        this.filter.spaces.filterValue.forEach((filterItem) => {
          filterString += `;:${filterItem.id}`;
        });
        currentUrl.searchParams.set('spaceFilter', filterString);
      } else if (spaceFilter) {
        currentUrl.searchParams.delete('spaceFilter');
      }

      // check if fpContributionFilters are active
      let hasFilterValues = false;
      let filterString = '';
      Object.values(this.fpConfigurationFilter).forEach((value) => {
        if (value.filterValue.length) {
          hasFilterValues = true;
          value.filterValue.forEach((filterItem) => {
            filterString += `;:${filterItem.id}`;
          });
          currentUrl.searchParams.set('fpConfigFilter', filterString);
        }
        if (!hasFilterValues) {
          currentUrl.searchParams.delete('fpConfigFilter');
        }
      });


      // update url with current filters
      window.history.replaceState(null, document.title, currentUrl.toString());
    },
    uniqueArray(value, index, self) {
      return self.indexOf(value) === index;
    },
    fetchSplittedCategories() {
      SolrService.getCategories(this.parsedLimitedFairUids)
        .then((response) => {
          if (response.data.grouped
            && response.data.grouped.fair_id
            && response.data.grouped.fair_id.groups) {
            this.fillCategorySelects(response.data.grouped.fair_id.groups);
          }
        })
        .catch((error) => {
          console.error('error: ', error);
        })
        .finally(() => {
          this.updateView();
          this.splittedCategoriesLoaded = true;
        });
    },
    fillCategorySelects(categoryObjects) {
      this.filter.categoriesByFair = {};
      this.filter.extraCategoriesByFair = {};
      [].forEach.call(categoryObjects, (categoryObject) => {
        const fairId = parseInt(categoryObject.doclist.docs[0].fair_id, 10);
        const fairCategories = categoryObject.doclist.docs[0].av_categories_fair || [];
        const fairCategoriesExtra = categoryObject.doclist.docs[0].av_categories_fair_extra || [];

        if (fairCategories.length) {
          this.filter.categoriesByFair[fairId] = {
            options: this.buildPathTree(fairCategories),
            filterValue: [],
            defaultExpandLevel: this.filter.categories.defaultExpandLevel,
            visible: false
          };
        }

        if (fairCategoriesExtra.length) {
          this.filter.extraCategoriesByFair[fairId] = {
            options: this.buildPathTree(fairCategoriesExtra),
            filterValue: [],
            defaultExpandLevel: this.filter.extraCategories.defaultExpandLevel,
            visible: false
          };
        }
      });
    },
    loadMoreEntries() {
      if (this.speakers) {
        this.fetchSpeakers(this.list.displayedAmount, this.amountToLoad, false);
      } else if (this.frameworkProgram) {
        this.fetchFrameworkProgram(this.list.displayedAmount, this.amountToLoad, false);
      } else if (this.exhibitors) {
        this.fetchExhibitors(this.list.displayedAmount, this.amountToLoad, false);
      } else if (this.news) {
        this.fetchNews(this.list.displayedAmount, this.amountToLoad, false);
      } else if (this.products) {
        this.fetchProducts(this.list.displayedAmount, this.amountToLoad, false);
      } else if (this.all) {
        this.fetchAll(this.list.displayedAmount, this.amountToLoad, false);
      }
      this.list.displayedAmount = this.list.displayedAmount + this.amountToLoad;
    },
    updateView() {
      /*
      viewSizeMode:
       0: <= 768
       1: > 768 && <= 1024
       2: > 1024 && <= 1280
       3: > 1280
      */
      if (this.viewSizeMode === 2 && this.aside) {
        this.list.isTileMode = true;
        this.list.isSwitchVisible = false;
      } else if (this.viewSizeMode === 1) {
        this.list.isTileMode = true;
        this.list.isSwitchVisible = false;
        // this.setTreeselectExpandLevel(1);
      } else if (this.viewSizeMode === 0) {
        this.list.isTileMode = true;
        this.list.isSwitchVisible = false;
        // this.setTreeselectExpandLevel(0);
      } else if (this.viewSizeMode === 2 && !this.aside) {
        this.list.isTileMode = true;
        this.list.isSwitchVisible = false;
      } else if (this.viewSizeMode === 3 && !this.aside) {
        this.list.isTileMode = false;
        this.list.isSwitchVisible = true;
        this.filter.isFilterVisible = true;
      } else {
        if (!this.aside) {
          this.filter.isFilterVisible = true;
        }
        this.list.isSwitchVisible = true;
        // this.setTreeselectExpandLevel(1);
      }
    },
    buildPathTree(paths) {
      let currentPath;
      let lastPath;
      let node;
      let parent;
      const map = {
        '': {
          children: [],
        },
      };
      let stack = [''];

      for (let i = 0; i < paths.length; i += 1) {
        let nodes = '';

        /* split path into single layers ("|") */
        if (paths[i].val) {
          nodes = paths[i].val.split('|');
        } else {
          nodes = paths[i].split('|');
        }
        for (let j = 0; j < nodes.length; j += 1) {
          currentPath = `${nodes.slice(0, j + 1).join('|')}`;
          const name = nodes[nodes.length - 1];
          lastPath = stack[stack.length - 1];
          parent = map[lastPath];

          if (!map[currentPath]) {
            node = {
              id: currentPath,
              label: name,
              type: 'category',
              children: [],
            };
            parent.children.push(node);
            map[currentPath] = node;
          }
          stack.push(currentPath);
        }
        stack = stack.slice(0, 1);
      }
      return paths.length === 0 ? [] : clean(map[''].children);
    },
    sortHallValues(hallBuckets) {
      if (this.list.hallSortArray.length === 0) {
        return hallBuckets;
      }

      const newSorting = [];
      this.list.hallSortArray.forEach((hallName) => {
        [].forEach.call(hallBuckets, (hallBucket) => {
          if (hallBucket.val === hallName) {
            newSorting.push(hallBucket);
          }
        });
      });
      return newSorting;
    },
    sortCountriesValues(countriesBuckets) {
      return countriesBuckets.sort();
    },
    buildFairTree(fairGroups) {
      /* get all fairEvents from config */
      const options = [];
      let node;

      for (let i = 0; i < fairGroups.length; i += 1) {
        node = {
          id: fairGroups[i].id,
          label: fairGroups[i].title,
          type: 'fair',
        };
        options.push(node);
      }
      return options;
    },
    buildTypeTree(types) {
      const options = [];
      let node;
      for (let i = 0; i < types.length; i += 1) {
        node = {
          id: types[i].val,
          label: this.returnItemType(types[i].val),
          type: 'type',
        };
        options.push(node);
      }
      return options;
    },
    buildFPFilterTree(fpOptions) {
      const options = [];
      let node;
      for (let i = 0; i < fpOptions.length; i += 1) {
        node = {
          id: fpOptions[i].val,
          label: fpOptions[i].val,
          type: 'elements',
        };
        options.push(node);
      }
      return options;
    },
    buildFPTimeOfDayTree(dates) {
      const options = [];
      let node;
      for (let i = 0; i < dates.length; i += 1) {
        node = {
          id: dates[i].id,
          label: dates[i].label,
          type: 'timeOfDay',
        };
        options.push(node);
      }
      return options;
    },
    buildCountryTree(countries) {
      const options = [];
      let node;
      for (let i = 0; i < countries.length; i += 1) {
        node = {
          id: countries[i].val,
          label: countries[i].val,
          type: 'country',
        };
        options.push(node);
      }
      return options;
    },
    buildSpacesTree(spaces) {
      const options = [];
      let node;
      for (let i = 0; i < spaces.length; i += 1) {
        // get all Ics spaces (saved as 2 dimensional array)
        if (Array.isArray(spaces[i])) {
          node = {
            id: this.$t('filter.ics'),
            label: this.$t('filter.ics'),
            type: 'spaces',
            children: [],
          };
          // eslint-disable-next-line no-loop-func
          spaces[i][1].forEach((space) => {
            const children = {
              id: space,
              label: space,
              type: 'spaces',
            };
            node.children.push(children);
          });
        } else {
          node = {
            id: spaces[i],
            label: spaces[i],
            type: 'spaces',
          };
        }
        options.push(node);
      }
      return options;
    },
    buildFpConfigurationFilterTree(topics) {
      const filterTree = {};
      topics.forEach((topic) => {
        const topicTitle = topic.val.split('|')[0];
        const topicItem = topic.val.split('|')[1];

        if (topicItem) {
          const node = {
            id: topic.val,
            label: topicItem,
            type: topicTitle,
          };

          if (!filterTree[topicTitle]) {
            if (this.fpConfigurationFilter[topicTitle]) {
              filterTree[topicTitle] = {
                defaultExpandLevel: this.fpConfigurationFilter[topicTitle].defaultExpandLevel,
                filterValue: this.fpConfigurationFilter[topicTitle].filterValue,
                options: [],
              };
            } else {
              filterTree[topicTitle] = {
                defaultExpandLevel: 0,
                filterValue: [],
                options: [],
              };
            }
          }
          filterTree[topicTitle].options.push(node);
        }
      });

      return filterTree;
    },
    setFilterVisiblity(visibility) {
      this.filter.isFilterVisible = visibility;
    },
    // setNewsFilter() {
    //   this.filter.types.filterValue = [{
    //     id: SolrNewsTypeName,
    //     label: 'News',
    //     type: 'type',
    //   }];
    //   this.filter.fairGroups.filterValue = [];
    //   this.filter.halls.filterValue = [];
    //   this.filter.countries.filterValue = [];
    //   this.filter.categories.filterValue = [];
    //   this.filter.travelDestinations.filterValue = [];
    //   this.applyFilter();
    // },
    triggerAutocomplete() {
      if (!this.frameworkProgram && !this.speakers && !this.news && !this.products) {
        if (this.resultObject.term.trim().length > 0) {
          SolrService.getAutocompleteSuggetions(
            this.resultObject.term.trim(),
            this.pluginConfiguration.limitedFairEvents,
            this.filter.fairGroups.filterValue,
            this.filter.types.filterValue,
            this.filter.categories.filterValue,
            this.filter.extraCategories.filterValue,
            this.filter.travelDestinations.filterValue,
            this.filter.halls.filterValue,
          ).then((response) => {
            if (response.data.suggest.av[this.resultObject.term.trim()]) {
              let autocompleteResults = response.data.suggest.av[this.resultObject.term.trim()]
                .suggestions.slice(0, 10);

              // replace paths when suggestion is from other fair
              const currentFairIds = JSON.parse(this.pluginConfiguration.limitedFairEvents);
              autocompleteResults = autocompleteResults.map((result) => {
                const payload = JSON.parse(result.payload);
                const { context } = payload;
                let { path } = payload;
                const fairId = parseInt(context[0].split('__')[1], 10);

                // Find all suggestions from fairs that are not configured in the plugin
                if (!currentFairIds.includes(fairId)) {
                  if (path && path.length > 0) {
                    // Fix tree path (replace wrong path with the one from the correct fair)
                    this.categories.forEach((category) => {
                      const splittedCategories = category.val.split('|');
                      const lastCategory = splittedCategories[splittedCategories.length - 1];
                      if (lastCategory === result.term) {
                        path = category.val;
                      }
                    });

                    // Update the path in the payload
                    payload.path = path;
                    result.payload = JSON.stringify(payload);
                  }
                }
                return result;
              });

              autocompleteResults.sort(
                (a, b) => {
                  let sorting = 0;
                  if (a.term.toLowerCase() !== b.term.toLowerCase()) {
                    sorting = a.term.toLowerCase() < b.term.toLowerCase() ? -1 : 1;
                  }
                  return sorting;
                },
              );
              if (this.splittedCategories) {
                autocompleteResults = autocompleteResults.filter((result) => {
                  const payload = JSON.parse(result.payload);
                  if (payload.type) {
                    return payload.type !== 'category';
                  }
                  if (payload[0].type) {
                    return payload[0].type !== 'category';
                  }

                  return false;
                });
              }

              // @todo: LMS117SUS-2840 - remove
              if (this.resultObject.term.toLowerCase() === 'rom' || this.resultObject.term.toLowerCase() === 'roma' || this.resultObject.term.toLowerCase() === 'roma ') {
                const romaIndex = autocompleteResults.findIndex(ex => ex.term === 'ROMA KG');

                if (romaIndex > 0) {
                  const roma = autocompleteResults[romaIndex];
                  autocompleteResults.splice(romaIndex, 1);
                  autocompleteResults.splice(0, 0, roma);
                }
              }

              const sliceOption = this.viewSizeMode === 0 || this.viewSizeMode === 1 ? 3 : 10;


              this.filter.autocomplete.results = autocompleteResults.slice(0, sliceOption);
            } else {
              this.filter.autocomplete.results = [];
            }
            if (this.filter.autocomplete.results.length > 0) {
              this.filter.autocomplete.isVisible = true;
            }
          })
            .catch((error) => {
              console.error(error);
            });
        } else {
          this.filter.autocomplete.isVisible = false;
        }
      }
    },
    applySearch() {
      if (this.onlySearch) {
        this.options.isLoading = true;
        if (this.resultObject.payload === '') {
          this.resultObject.payload = '[{"type":"searchFromDifferentLocation"}]';
        }
        sessionStorage.setItem('lms_query', JSON.stringify(this.resultObject));
        window.location = this.listUrl;
      } else {
        this.list.itemsPushed = [];

        if (this.speakers) {
          this.fetchSpeakers(0, this.amountToLoad, true);
        } else if (this.frameworkProgram) {
          this.fetchFrameworkProgram(0, this.amountToLoad, true);
        } else if (this.exhibitors) {
          this.fetchExhibitors(0, this.amountToLoad, true);
        } else if (this.news) {
          this.fetchNews(0, this.amountToLoad, true);
        } else if (this.products) {
          this.fetchProducts(0, this.amountToLoad, true);
        } else if (this.all) {
          this.fetchAll(0, this.amountToLoad, false);
        }
      }
    },
    clearSearch() {
      this.resultObject.term = '';
      this.applySearch();
    },
    clearSearchWithoutNewRequest() {
      this.resultObject.term = '';
    },
    applySplittedCategoryFilter() {
      this.filter.categories.filterValue = [];
      const categoryKeys = Object.keys(this.filter.categoriesByFair);
      categoryKeys.forEach((categoryKey) => {
        if (this.filter.categoriesByFair[categoryKey]
          && this.filter.categoriesByFair[categoryKey].filterValue
          && this.filter.categoriesByFair[categoryKey].filterValue.length !== 0) {
          this.filter.categoriesByFair[categoryKey].filterValue.forEach((catObject) => {
            this.filter.categories.filterValue.push(catObject);
          });
        }
      });
      this.applyFilter();
    },
    applySplittedExtraCategoryFilter() {
      this.filter.extraCategories.filterValue = [];
      const categoryKeys = Object.keys(this.filter.extraCategoriesByFair);
      categoryKeys.forEach((categoryKey) => {
        if (this.filter.extraCategoriesByFair[categoryKey]
          && this.filter.extraCategoriesByFair[categoryKey].filterValue
          && this.filter.extraCategoriesByFair[categoryKey].filterValue.length !== 0) {
          this.filter.extraCategoriesByFair[categoryKey].filterValue.forEach((catObject) => {
            this.filter.extraCategories.filterValue.push(catObject);
          });
        }
      });
      this.applyFilter();
    },
    applyFilter() {
      // check if filter was already saved, so there are no multiple unnecessary requests
      if (!this.filterApplied) {
        this.list.itemsPushed = [];
        this.list.displayedAmount = this.amountToLoad;
        this.updateFiltersInUrl();
        if (this.speakers) {
          this.fetchSpeakers(0, this.amountToLoad, true);
          this.filterApplied = true;
        } else if (this.frameworkProgram) {
          this.fetchFrameworkProgram(0, this.amountToLoad, true);
          this.filterApplied = true;
        } else if (this.exhibitors) {
          this.fetchExhibitors(0, this.amountToLoad, true);
          this.filterApplied = true;
        } else if (this.news) {
          this.fetchNews(0, this.amountToLoad, true);
          this.filterApplied = true;
        } else if (this.products) {
          this.fetchProducts(0, this.amountToLoad, true);
          this.filterApplied = true;
        } else if (this.all) {
          this.fetchAll(0, this.amountToLoad, false);
          this.filterApplied = true;
        }
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      }
      this.filterApplied = false;
    },
    selectedFilterCategory(item) {
      this.filter.categories.filterValue = [item];
      this.applyFilter();
      this.closeDetail();
    },
    resetSplittedCategoryFilterTree(fairUid) {
      this.filter.categoriesByFair[fairUid].filterValue = [];
      this.applySplittedCategoryFilter();
    },
    resetSplittedExtraCategoryFilterTree(fairUid) {
      this.filter.extraCategoriesByFair[fairUid].filterValue = [];
      this.applySplittedExtraCategoryFilter();
    },
    resetFilterTree(filterName) {
      if (filterName === 'timeOfDay') {
        this.filter[filterName].filterValue = {id: 'day', label: 'Ganzer Tag'};
      } else if (this.fpConfigurationFilter[filterName]) {
        this.fpConfigurationFilter[filterName].filterValue = [];
      } else {
        this.filter[filterName].filterValue = [];
        if (filterName === 'categories' && this.filter.categoriesByFair) {
          const categoryKeys = Object.keys(this.filter.categoriesByFair);
          categoryKeys.forEach((key) => {
            if (this.filter.categoriesByFair[key]) {
              this.filter.categoriesByFair[key].filterValue = [];
            }
          });
        }
        if (filterName === 'extraCategories' && this.filter.extraCategoriesByFair) {
          const categoryKeys = Object.keys(this.filter.extraCategoriesByFair);
          categoryKeys.forEach((key) => {
            if (this.filter.extraCategoriesByFair[key]) {
              this.filter.extraCategoriesByFair[key].filterValue = [];
            }
          });
        }
      }
      this.applyFilter();
    },
    resetFilters() {
      this.filter.fairGroups.filterValue = [];
      this.filter.halls.filterValue = [];
      this.filter.countries.filterValue = [];
      this.filter.types.filterValue = [];
      this.filter.categories.filterValue = [];
      this.filter.extraCategories.filterValue = [];
      this.filter.spaces.filterValue = [];
      if (this.splittedCategories) {
        const categoryKeys = Object.keys(this.filter.categoriesByFair);
        categoryKeys.forEach((key) => {
          if (this.filter.categoriesByFair[key]) {
            this.filter.categoriesByFair[key].filterValue = [];
          }
        });
        const extraCategoryKeys = Object.keys(this.filter.extraCategoriesByFair);
        extraCategoryKeys.forEach((key) => {
          if (this.filter.extraCategoriesByFair[key]) {
            this.filter.extraCategoriesByFair[key].filterValue = [];
          }
        });
      }
      if (this.fpConfigurationFilter) {
        Object.keys(this.fpConfigurationFilter).forEach((key) => {
          this.fpConfigurationFilter[key].filterValue = [];
        });
      }
      this.filter.travelDestinations.filterValue = [];
      this.applyFilter();
    },
    setCursorPosition() {
      const { search } = this.$refs;

      this.$nextTick(() => {
        search.focus();
        search.setSelectionRange(
          this.resultObject.term.length, this.resultObject.term.length,
        );
      });
    },
    autocompleteSearch(autocompleteItem) {
      autocompleteItem.term = `"${autocompleteItem.term}"`;
      const payload = JSON.parse(autocompleteItem.payload);

      this.resultObject = autocompleteItem;
      switch (payload.type) {
        case 'category':
          this.filter.categories.filterValue.push({
            id: payload.path,
            label: payload.value,
            type: payload.type,
          });
          this.clearSearchWithoutNewRequest();
          this.applyFilter();
          break;
        case 'traveldestination':
          this.filter.travelDestinations.filterValue.push({
            id: payload.path,
            label: payload.value,
            type: payload.type,
          });
          this.clearSearchWithoutNewRequest();
          this.applyFilter();
          break;
        default:
          this.$refs.searchButton.click();
      }
      this.closeAutocomplete();
    },
    autocompleteItemWithHighlight(item) {
      const payload = JSON.parse(item.payload);
      let returnHtml = '';

      if (payload.type === 'category') {
        returnHtml = `<span class="ed-filter__autocompleteItem--type">${this.$t('filter.category')}</span>`;
      } else if (payload.type === 'traveldestination') {
        returnHtml = `<span class="ed-filter__autocompleteItem--type">${this.$t('filter.travelDestination')}</span>`;
      }
      returnHtml += '<span class="ed-filter__autocompleteItem--title">';
      returnHtml += item.term.toString().replace(new RegExp(this.resultObject.term.trim(), 'ig'), match => `<span class="ed-filter__autocompleteItemHighlight">${match} </span>`);
      returnHtml += '</span>';

      return returnHtml;
    },
    onAutocompleteArrowDown() {
      if (this.filter.autocomplete.arrowCounter
        < this.filter.autocomplete.results.length - 1
        && this.filter.autocomplete.isVisible) {
        this.filter.autocomplete.arrowCounter = this.filter.autocomplete.arrowCounter + 1;
      }
      if (this.filter.autocomplete.isVisible) {
        this.setCursorPosition();
      }
    },
    onAutocompleteArrowUp() {
      if (this.filter.autocomplete.arrowCounter > 0 && this.filter.autocomplete.isVisible) {
        this.filter.autocomplete.arrowCounter = this.filter.autocomplete.arrowCounter - 1;
      }
      if (this.filter.autocomplete.isVisible) {
        this.setCursorPosition();
      }
    },
    onAutocompleteEnter() {
      if (this.filter.autocomplete.arrowCounter !== -1) {
        this.resultObject = this
          .filter
          .autocomplete
          .results[this.filter.autocomplete.arrowCounter];
        this.resultObject.term = `"${this.resultObject.term}"`;
        this.closeAutocomplete();
      }
    },
    closeAutocomplete() {
      this.filter.autocomplete.isVisible = false;
      this.filter.autocomplete.arrowCounter = -1;
    },
    setTileMode(value) {
      this.list.isTileMode = value;
    },
    updateRoute(entry) {
      const numericId = this.getNumericId(entry.id);
      if (entry.type === SolrSpeakerTypeName) {
        this.$router.push({ name: 'SpeakerDetail', params: { speakerId: numericId } });
      } else if (entry.type === SolrFrameworkProgramTypeName) {
        this.$router.push({ name: 'FrameworkProgramDetail', params: { programId: numericId } });
      } else if (entry.type === SolrExhibitorTypeName) {
        this.$router.push({ name: 'ExhibitorDetail', params: { exhibitorId: numericId } });
      } else if (entry.type === SolrNewsTypeName) {
        this.$router.push({ name: 'NewsDetail', params: { newsId: numericId } });
      } else if (entry.type === SolrProductTypeName) {
        this.$router.push({ name: 'ProductDetail', params: { productId: numericId } });
      }
    },
    showDetail(entryId) {
      if (this.speakers) {
        SolrService.getSpeakerData(`id:${entryId}`, 0, 10, this.list.sorting,
          this.pickedDate, this.filter.timeOfDay.filterValue, this.pluginConfiguration.limitedFairEvents,
          this.filter.spaces.filterValue).then((response) => {
          if (response.data.response.docs[0]) {
            this.detail.entry = response.data.response.docs[0]; // eslint-disable-line
            this.detail.isDetailVisible = true;
            const targetElement = document.querySelector('#detail-modal');
            disableBodyScroll(targetElement);
          } else {
            /* no data for this id found -> list */
            this.closeDetail();
          }
        });
      } else if (this.frameworkProgram) {
        SolrService.getFrameworkProgramData(`id:${entryId}`, 0, 10,
          this.list.sorting,
          this.pickedDate,
          this.filter.timeOfDay.filterValue,
          this.filter.categories.filterValue,
          this.filter.spaces.filterValue,
          this.fpConfigurationFilter,
          this.favourites.showFavourites,
          this.getFavourites(),
          this.pluginConfiguration.limitedFairEvents).then((response) => {
          if (response.data.response.docs[0]) {
            this.detail.entry = response.data.response.docs[0]; // eslint-disable-line
            this.detail.isDetailVisible = true;
            const targetElement = document.querySelector('#detail-modal');
            disableBodyScroll(targetElement);
          } else {
            /* no data for this id found -> list */
            this.closeDetail();
          }
        });
      } else if (this.exhibitors) {
        SolrService.getExhibitorData(
          `id:${entryId}`,
          this.pluginConfiguration.limitedFairEvents,
          this.filter.types.filterValue,
          this.filter.categories.filterValue,
          this.filter.extraCategories.filterValue,
          this.favourites.showFavourites,
          this.getFavourites(),
          this.filter.travelDestinations.filterValue,
          this.filter.fairGroups.filterValue,
          this.filter.halls.filterValue,
          this.filter.countries.filterValue,
          0,
          10, // eslint-disable-line
        ).then((response) => {
          if (response.data.response.docs[0]) {
            this.detail.entry = response.data.response.docs[0]; // eslint-disable-line
            this.detail.isDetailVisible = true;
            const targetElement = document.querySelector('#detail-modal');
            disableBodyScroll(targetElement);
          } else {
            /* no data for this id found -> list */
            this.closeDetail();
          }
        });
      } else if (this.news) {
        SolrService.getNewsData(`id:${entryId}`, 0, 10, this.list.sorting, this.pluginConfiguration.limitedFairEvents, this.favourites.showFavourites,
          this.getFavourites()).then((response) => {
          if (response.data.response.docs[0]) {
            this.detail.entry = response.data.response.docs[0]; // eslint-disable-line
            this.detail.isDetailVisible = true;
            const targetElement = document.querySelector('#detail-modal');
            disableBodyScroll(targetElement);
          } else {
            /* no data for this id found -> list */
            this.closeDetail();
          }
        });
      } else if (this.all) {
        SolrService.getAllData(
          `id:${entryId}`,
          this.pluginConfiguration.limitedFairEvents,
          this.filter.types.filterValue,
          this.filter.categories.filterValue,
          this.filter.extraCategories.filterValue,
          this.favourites.showFavourites,
          this.getFavourites(),
          this.filter.travelDestinations.filterValue,
          this.filter.fairGroups.filterValue,
          this.filter.halls.filterValue,
          this.filter.countries.filterValue,
          0,
          10,
        ).then((response) => {
          if (response.data.response.docs[0]) {
            this.detail.entry = response.data.response.docs[0]; // eslint-disable-line
            this.detail.isDetailVisible = true;
            const targetElement = document.querySelector('#detail-modal');
            disableBodyScroll(targetElement);
          } else {
            /* no data for this id found -> list */
            this.closeDetail();
          }
        });
      }
    },
    closeDetail(event) {
      if (event && event.path && event.path[0].classList.contains('modal-back--video')) {
        return;
      }
      if (this.router.oldRoute) {
        this.$router.push({ name: this.router.oldRoute.name, params: this.router.oldRoute.params });
      } else {
        if (this.all && this.$route.name !== 'Directory') {
          this.$router.push({ name: 'Directory' });
        } else if (this.$route.name === 'SpeakerDetail') {
          this.$router.push({ name: 'Speaker' });
        } else if (this.$route.name === 'FrameworkProgramDetail') {
          this.$router.push({ name: 'FrameworkProgram' });
        } else if (this.$route.name === 'ExhibitorDetail') {
          this.$router.push({ name: 'Exhibitor' });
        } else if (this.$route.name === 'NewsDetail') {
          this.$router.push({ name: 'News' });
        } else if (this.$route.name === 'ProductDetail') {
          this.$router.push({ name: 'Product' });
        }
        this.detail.isDetailVisible = false;
        this.detail.entry = null;
        clearAllBodyScrollLocks();
      }
    },
    isProductsNotEmpty(products) {
      if (!products) {
        return false;
      }
      return products.length !== 0;
    },
    getFavourites() {
      if (this.exhibitors || this.all || this.news) {
        return JSON.parse(StorageService.getItem('favourites')) || [];
      }
      if (this.frameworkProgram) {
        return JSON.parse(StorageService.getItem('favouritesProgram')) || [];
      }
      return [];
    },
    toggleFavourites() {
      if (this.all) {
        this.favourites.items = this.getFavourites();
        if (this.favourites.showFavourites) {
          this.$router.push({name: 'Directory'});
        } else {
          this.$router.push({name: 'ExhibitorFavourites'});
        }
      } else if (this.news) {
        this.favourites.items = this.getFavourites();
        if (this.favourites.showFavourites) {
          this.$router.push({name: 'News'});
        } else {
          this.$router.push({name: 'ExhibitorFavourites'});
        }
      } else if (this.exhibitors) {
        this.favourites.items = this.getFavourites();
        if (this.favourites.showFavourites) {
          this.$router.push({name: 'Exhibitor'});
        } else {
          this.$router.push({name: 'ExhibitorFavourites'});
        }
      } else if (this.frameworkProgram) {
        this.favourites.itemsProgram = this.getFavourites();
        if (this.favourites.showFavourites) {
          this.$router.push({name: 'FrameworkProgram'});
        } else {
          this.$router.push({name: 'ProgramFavourites'});
        }
      }

      this.favourites.showFavourites = !this.favourites.showFavourites;
      this.applyFilter();
    },
    async openPrintDialogue() {
      // fetch can cause long loading times!
      if (this.all) {
        await this.fetchAll(this.list.displayedAmount, this.getCount.all, false);
      }
      if (this.exhibitors) {
        await this.fetchExhibitors(this.list.displayedAmount, this.getCount.exhibitor, false);
      }
      window.print();
    },
    setFavourite(id) {
      const existingEntries = this.getFavourites();
      if (existingEntries.includes(id)) {
        const index = existingEntries.indexOf(id);
        if (index > -1) {
          existingEntries.splice(index, 1);
        }
      } else {
        existingEntries.push(id);
      }
      if (this.exhibitors || this.all || this.news) {
        StorageService.setItem('favourites', JSON.stringify(existingEntries));
        this.favourites.items = this.getFavourites();
      } else if (this.frameworkProgram) {
        StorageService.setItem('favouritesProgram', JSON.stringify(existingEntries));
        this.favourites.itemsProgram = this.getFavourites();
      }
      this.$forceUpdate();
      if (this.favourites.showFavourites) {
        this.applyFilter();
      }
    },
    isFavourite(id) {
      const existingEntries = this.getFavourites();
      if (existingEntries.includes(id)) {
        const index = existingEntries.indexOf(id);
        return index > -1;
      }
      return false;
    },
    clearFavourites() {
      if (this.exhibitors || this.all || this.news) {
        StorageService.removeItem('favourites');
        this.favourites.items = this.getFavourites();
      } else if (this.frameworkProgram) {
        StorageService.removeItem('favouritesProgram');
        this.favourites.itemsProgram = this.getFavourites();
      }
      this.favourites.showFavourites = false;
      this.applyFilter();
    },
    setTreeselectExpandLevel(level) {
      const { treeselect } = this.$refs;
      if (treeselect !== undefined) {
        treeselect.traverseAllNodesByIndex((node) => {
          if (node.isRootNode) {
            node.isExpanded = level; // eslint-disable-line no-param-reassign
          }
        });
      }
    },
    formatNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    toggleProductAccordion() {
      this.detail.isProductAccordionOpen = !this.detail.isProductAccordionOpen;
    },
    toggleAccordion(event) {
      const panel = event.target.children[0];
      event.target.classList.toggle('active');
      panel.style.maxHeight = 100;
    },
    resetAccordions() {
      this.detail.isProductAccordionOpen = false;
      this.detail.isCategoryAccordionOpen = false;
      this.detail.isContactAccordionOpen = false;
    },
    printDetail() {
      window.print();
    },
    returnItemType(type) {
      switch (type) {
        case SolrExhibitorTypeName:
          return this.$t('list.type.exhibitor');
        case SolrProductTypeName:
          return this.$t('list.type.product');
        case SolrNewsTypeName:
          return this.$t('list.type.news');
        case SolrBrandTypeName:
          return this.$t('list.type.brand');
        default:
          return '';
      }
    },
    returnSocialMediaName(smType) {
      const type = parseInt(smType, 10);
      switch (type) {
        case 0:
          return 'Facebook';
        case 1:
          return 'Twitter';
        case 2:
          return 'LinkedIn';
        case 3:
          return 'YouTube';
        case 4:
          return 'Xing';
        case 5:
          return 'Instagram';
        case 6:
          return 'WhatsApp';
        case 7:
          return 'Snapchat';
        case 8:
          return 'Facebook Messenger';
        default:
          return '';
      }
    },
    getCategoryWithSpaces(category) {
      return category.replace(/\|/g, ' | ');
    },
    getNumericId(id) {
      const splittedId = id.split('|||');
      return splittedId[splittedId.length - 1];
    },
    fetchDataFromRouter() {
      if (this.all) {
        if (this.$route.params.exhibitorId) {
          this.showDetail(`${SolrExhibitorTypeName}|||${this.$route.params.exhibitorId}`);
        } else if (this.$route.params.newsId) {
          this.showDetail(`${SolrNewsTypeName}|||${this.$route.params.newsId}`);
        }
      } else if (this.$route.params.exhibitorId) {
        this.speakers = false;
        this.frameworkProgram = false;
        this.exhibitors = true;
        this.news = false;
        this.products = false;
        this.showDetail(`${SolrExhibitorTypeName}|||${this.$route.params.exhibitorId}`);
      } else if (this.$route.params.speakerId) {
        this.speakers = true;
        this.exhibitors = false;
        this.frameworkProgram = false;
        this.news = false;
        this.products = false;
        this.showDetail(`${SolrSpeakerTypeName}|||${this.$route.params.speakerId}`);
      } else if (this.$route.params.programId) {
        this.speakers = false;
        this.exhibitors = false;
        this.frameworkProgram = true;
        this.news = false;
        this.products = false;
        this.showDetail(`${SolrFrameworkProgramTypeName}|||${this.$route.params.programId}`);
      } else if (this.$route.params.newsId) {
        this.speakers = false;
        this.exhibitors = false;
        this.frameworkProgram = false;
        this.news = true;
        this.products = false;
        this.showDetail(`${SolrNewsTypeName}|||${this.$route.params.newsId}`);
      } else if (this.$route.params.productId) {
        this.speakers = false;
        this.exhibitors = false;
        this.frameworkProgram = false;
        this.news = false;
        this.products = true;
        this.showDetail(`${SolrProductTypeName}|||${this.$route.params.productId}`);
      } else {
        this.closeDetail();
      }
    },
    // getBoothsForFair(item) {
    //   const fairs = [];
    //   const boothsInFair = [];
    //   if (item['_childDocuments_']) { // eslint-disable-line
    //     item['_childDocuments_'].forEach((fair) => { // eslint-disable-line
    //       fairs.push(fair.fair_id);
    //     });
    //     item.av_booths.forEach((booth) => {
    //       if (fairs.indexOf(booth.fairId) !== -1) {
    //         boothsInFair.push(booth);
    //       }
    //     });
    //   }
    //   return boothsInFair;
    // },
    filteredChildDocuments(exhibitor) {
      const documents = [];
      if (exhibitor._childDocuments_) {
        exhibitor._childDocuments_.forEach((childDoc) => {
          let found = false;
          if (exhibitor.fair_ids.includes(childDoc.fair_id)) {
            documents.forEach((document) => {
              if (document.fair_id === childDoc.fair_id) {
                found = true;
              }
            });
            if (!found) {
              documents.push(childDoc);
            }
          }
        });
        return documents;
      }
      return [];
    },
    parseHexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    fillHallSortingValues() {
      switch (LanguageService.getCurrentTYPO3Language()) {
        case 'en':
          this.list.hallSortArray = [
            'Entrance East',
            'Entrance West',
            'Atrium',
            'Hall 1',
            'Gallery hall 1',
            'Glasshall Floor -1',
            'Hall 2',
            'Hall 3',
            'Hall 4',
            'Hall 5',
            'Hall 6',
            'Hall 7',
            'Hall 8',
            'Hall 9',
            'Hall 10',
            'ICS',
            'Hall C1',
            'Rothaus-Park',
            'Messepiazza',
            'Undefined'
          ];
          break;
        case 'de':
          this.list.hallSortArray = [
            'Eingang Ost',
            'Eingang West',
            'Atrium',
            'Halle 1',
            'Galerie Halle 1',
            'Glashalle Ebene -1',
            'Halle 2',
            'Halle 3',
            'Halle 4',
            'Halle 5',
            'Halle 6',
            'Halle 7',
            'Halle 8',
            'Halle 9',
            'Halle 10',
            'ICS',
            'Halle C1',
            'Rothaus-Park',
            'Messepiazza',
            'Undefiniert'
          ];
          break;
        default:
      }
    },
    handleScroll() {
      this.showToTopButton = window.scrollY >= 500;
    },
    async fetchFrameworkProgram(offset, rows, firstLoad) {
      this.list.isLoading = true;
      try {
        const response = await SolrService.getFrameworkProgramData(
          this.resultObject.term.trim() ? this.resultObject.term.trim().toLowerCase() : '*:*',
          offset,
          rows,
          this.list.sorting,
          this.pickedDate,
          this.filter.timeOfDay.filterValue,
          this.filter.categories.filterValue,
          this.filter.spaces.filterValue,
          this.fpConfigurationFilter,
          this.favourites.showFavourites,
          this.getFavourites(),
          this.pluginConfiguration.limitedFairEvents
        );
        this.list.amount = response.data.response.numFound;
        this.list.offset = response.data.response.start;
        this.list.countOfTypes = response.data.facets.typeReduced.buckets;

        if (this.list.lastSort === this.list.sorting) {
          if (firstLoad) {
            this.list.itemsPushed = response.data.response.docs;
          } else {
            this.list.itemsPushed.push(...response.data.response.docs);
          }
        } else {
          this.list.itemsPushed = response.data.response.docs;
          this.list.lastSort = this.list.sorting;
        }
        this.list.items = this.list.itemsPushed.reduce((newArray, arrayItem) => {
          const date = this.getFormattedDate(arrayItem.fp_starttime);
          const returnArray = newArray;
          if (returnArray[date]) {
            returnArray[date].push(arrayItem);
          } else {
            returnArray[date] = [arrayItem];
          }
          return returnArray;
        }, {});

        this.filter.timeOfDay.options = this.buildFPTimeOfDayTree(this.filter.timeOfDay.options);

        if (response.data.facets.topics) {
          this.fpConfigurationFilter = this.buildFpConfigurationFilterTree(response.data.facets.topics.buckets);
        }
        if (response.data.facets.categories) {
          this.filter.categories.options = this.buildFPFilterTree(response.data.facets.categories.buckets);
        }
        if (response.data.facets.spaces) {
          const spaces = this.getSpaceFacetValues(response.data.facets.spaces.buckets);
          this.filter.spaces.options = this.buildSpacesTree(spaces);
        }
      } catch (e) {
        console.error(e);
      }
      this.list.isLoading = false;
    },
    async fetchSpeakers(offset, rows, firstLoad) {
      this.list.isLoading = true;
      try {
        const response = await SolrService.getSpeakerData(
          this.resultObject.term.trim() ? this.resultObject.term.trim().toLowerCase() : '*:*',
          offset,
          rows,
          this.list.sorting,
          this.pickedDate,
          this.filter.timeOfDay.filterValue,
          this.pluginConfiguration.limitedFairEvents,
          this.filter.spaces.filterValue
        );
        this.list.amount = response.data.response.numFound;
        this.list.offset = response.data.response.start;
        this.list.countOfTypes = response.data.facets.typeReduced.buckets;

        if (this.list.lastSort === this.list.sorting) {
          if (firstLoad) {
            this.list.itemsPushed = response.data.response.docs;
          } else {
            this.list.itemsPushed.push(...response.data.response.docs);
          }
        } else {
          this.list.itemsPushed = response.data.response.docs;
          this.list.lastSort = this.list.sorting;
        }
        this.list.items = this.list.itemsPushed.reduce((newArray, arrayItem) => {
          const reg = /[a-zA-Z]/;
          let firstLetter;

          if (arrayItem.fp_lastname !== undefined && arrayItem.fp_lastname !== '') {
            if (!reg.test(arrayItem.fp_lastname[0])) {
              firstLetter = '#';
            } else {
              firstLetter = arrayItem.fp_lastname[0].toLocaleUpperCase();
            }
          } else if (arrayItem.fp_firstname !== undefined && arrayItem.fp_firstname !== '') {
            if (!reg.test(arrayItem.fp_firstname[0])) {
              firstLetter = '#';
            } else {
              firstLetter = arrayItem.fp_firstname[0].toLocaleUpperCase();
            }
          } else {
            firstLetter = '#';
          }

          const returnArray = newArray;
          if (returnArray[firstLetter]) {
            returnArray[firstLetter].push(arrayItem);
          } else {
            returnArray[firstLetter] = [arrayItem];
          }
          return returnArray;
        }, {});

        this.filter.timeOfDay.options = this.buildFPTimeOfDayTree(this.filter.timeOfDay.options);
        if (response.data.facets.spaces) {
          const spaces = this.getSpaceFacetValues(response.data.facets.spaces.buckets);
          this.filter.spaces.options = this.buildSpacesTree(spaces);
        }
      } catch (e) {
        console.error(e);
      }
      this.list.isLoading = false;
    },
    async fetchNews(offset, rows, firstLoad) {
      this.list.isLoading = true;
      try {
        const response = await SolrService.getNewsData(
          this.resultObject.term.trim() ? this.resultObject.term.trim().toLowerCase() : '*:*',
          offset,
          rows,
          this.list.sorting,
          this.pluginConfiguration.limitedFairEvents,
          this.favourites.showFavourites,
          this.getFavourites()
        );
        this.list.amount = response.data.response.numFound;
        this.list.offset = response.data.response.start;
        this.list.countOfTypes = response.data.facets.typeReduced.buckets;

        if (this.list.lastSort === this.list.sorting) {
          if (firstLoad) {
            this.list.itemsPushed = response.data.response.docs;
          } else {
            this.list.itemsPushed.push(...response.data.response.docs);
          }
        } else {
          this.list.itemsPushed = response.data.response.docs;
          this.list.lastSort = this.list.sorting;
        }
        this.list.items = this.list.itemsPushed.reduce((newArray, arrayItem) => {
          const date = this.getFormattedDate(arrayItem.date);
          const returnArray = newArray;
          if (returnArray[date]) {
            returnArray[date].push(arrayItem);
          } else {
            returnArray[date] = [arrayItem];
          }
          return returnArray;
        }, {});
      } catch (e) {
        console.error(e);
      }
      this.list.isLoading = false;
    },
    getFormattedDate(dateObject) {
      const date = new Date(dateObject);

      const options = {
        weekday: 'short', // short weekday name
        day: '2-digit', // day with leading zero if necessary
        month: '2-digit', // month with leading zero if necessary
        year: 'numeric', // full year
        timeZone: 'Europe/Berlin',
      };

      const formatter = new Intl.DateTimeFormat(this.getLocale, options);
      let formattedDate = formatter.format(date);

      // Remove the comma and point after the weekday, if present
      formattedDate = formattedDate.replace(/,\s*/, ' ').replace(/\.\s*/, ' ');
      return formattedDate;
    },
    getFormattedDateTime(entry) {
      const starttime = new Date(entry.fp_starttime).toLocaleTimeString(this.getLocale, { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' });
      const endtime = new Date(entry.fp_endtime).toLocaleTimeString(this.getLocale, { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' });
      return `${starttime}  -  ${endtime}`;
    },
    getFormattedOrganizerSpace(item) {
      const place = this.getOrganizerSpace(item);
      if (place !== '') {
        // check if place is a ICS place, if ICS is updated the const needs an update too
        if (ICS_LOCATIONS.includes(place)) {
          return `ICS, ${place}`;
        }

        const reg = new RegExp('([A-Za-z])');
        const index = place.match(reg);
        if (index && index.index !== 0) {
          return `${this.$t('detail.fairBooths.hall')} ${place.slice(0, index.index)}, ${place}`;
        }
      }
      return place;
    },
    getOrganizerSpace(item) {
      if (item.fp_space) {
        let organizerSpace;
        try {
          organizerSpace = JSON.parse(item.fp_space[0]);
          organizerSpace = organizerSpace.translations.de.title;
        } catch {
          // eslint-disable-next-line prefer-destructuring
          organizerSpace = item.fp_space[0];
        }
        // old RPP event at own booth
        if (organizerSpace === 'Veranstaltung am Messestand' && item.fp_organizer_space) {
          return item.fp_organizer_space[0];
        }
        // new RPP event at own booth
        if (!organizerSpace && item.fp_organizer_space && item.fp_organizer_space.length && item.fp_organizer_space[0]) {
          return `${this.$t('detail.fairBooths.booth')} ${item.fp_organizer_space[0]}`;
        }
        return organizerSpace;
      }
      return '';
    },
    getContacts(entry) {
      const parsedContacts = [];
      if (entry.contacts) {
        let contacts;
        try {
          contacts = JSON.parse(entry.contacts);
        } catch {
          // eslint-disable-next-line prefer-destructuring
          contacts = entry.contacts;
        }

        if (contacts.length > 0) {
          for (let i = 0; i < contacts.length; i += 1) {
            if (contacts[i].person) {
              if (contacts[i].person.translations) {
                parsedContacts.push({
                  role: contacts[i].roleId,
                  title: contacts[i].person.translations.de.title || contacts[i].person.title,
                  surname: contacts[i].person.name,
                  name: contacts[i].person.surname,
                  image: contacts[i].person.image,
                  position: contacts[i].person.position,
                  company: contacts[i].person.company,
                  salutation: contacts[i].person.salutation,
                });
              }
            }
          }
        }
      }
      return parsedContacts;
    }
  },
  directives: {
    ClickOutside,
    infiniteScroll,
  },
  watch: {
    $route(route, oldRoute) {
      if (route.name === 'ExhibitorNews') {
        this.router.oldRoute = oldRoute;
      } else {
        this.router.oldRoute = null;
      }
      this.fetchDataFromRouter();
    },
    'filter.fairGroups.filterValue': {
      handler(fairGroups) {
        if (this.splittedCategories) {
          const categoryKeys = Object.keys(this.filter.categoriesByFair);
          categoryKeys.forEach((categoryKey) => {
            this.filter.categoriesByFair[categoryKey].visible = false;
            if (this.filter.extraCategoriesByFair[categoryKey]) {
              this.filter.extraCategoriesByFair[categoryKey].visible = false;
            }
          });
          [].forEach.call(fairGroups, (fairGroup) => {
            if (this.filter.categoriesByFair[fairGroup.id]) {
              this.filter.categoriesByFair[fairGroup.id].visible = true;
            }
            if (this.filter.extraCategoriesByFair[fairGroup.id]) {
              this.filter.extraCategoriesByFair[fairGroup.id].visible = true;
            }
          });
        }
      }
    },
    // this has to be watchers, because of async method (not computed properties)
    frameworkProgram() {
      if (this.frameworkProgram) {
        this.fetchFrameworkProgram(0, this.amountToLoad, true).then(() => {
          this.checkForUrlParams();
          this.filterApplied = false;
        });
        return true;
      }
      return false;
    },
    speakers() {
      if (this.speakers) {
        this.fetchSpeakers(0, this.amountToLoad, true).then(() => {
          this.checkForUrlParams();
          this.filterApplied = false;
        });
        return true;
      }
      return false;
    },
    exhibitors() {
      if (this.exhibitors) {
        this.fetchExhibitors(0, this.amountToLoad, true).then(() => {
          this.checkForUrlParams();
          this.filterApplied = false;
        });
        return true;
      }
      return false;
    },
    news() {
      if (this.news) {
        this.fetchNews(0, this.amountToLoad, true);
        return true;
      }
      return false;
    },
    all() {
      if (this.all) {
        this.fetchAll(0, this.amountToLoad, true).then(() => {
          this.checkForUrlParams();
          this.filterApplied = false;
        });
        return true;
      }
      return false;
    },
  },
};
